import isNil from 'lodash/isNil';

import { ProfOfferHouse, RentLivingTenantRequirements } from '@search/graphql-typings';
import { buildInfoLand, buildMainInfoLand } from './build_InfoLand';
import { getBathroomInHouse, getBuildYearHouse, getFloorsHouse, getHeating, getHouseArea, getHouseType, getLivingFacilities, getRoomsInHouse, getTenantsInfoB2c, getTenantsInfoB2b } from './infoHelpers';
import { mapToInformations, InfoModelRaw, InformationsEnum, InformationsIconEnum, TGenerateSeoUrlParams } from './infoHelpers/types/InfoModel';

export function buildInfoHouse(
    house: ProfOfferHouse,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        useB2cFuncs?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    }
) {
    const land = isNil(house.land) ?
        [] : buildInfoLand(
            house.land,
            undefined,
            {
                useLandIcon: true,
                useB2cFuncs: params?.useB2cFuncs,
                generateUrl: params?.generateUrl
            }
        );

    const informationsRaw: InfoModelRaw[] = [
        {
            title: 'Площадь дома',
            value: getHouseArea(house),
            key: InformationsEnum.houseArea,
            icon: InformationsIconEnum.totalArea
        },
        ...land,
        {
            title: 'Год постройки',
            value: getBuildYearHouse(house),
            key: InformationsEnum.houseBuildYear,
            icon: InformationsIconEnum.buildYear
        },
        {
            title: 'Этажность',
            value: getFloorsHouse(house),
            key: InformationsEnum.houseFloors,
            icon: InformationsIconEnum.floors
        },
        {
            title: 'Комнат',
            value: getRoomsInHouse(house),
            key: InformationsEnum.houseRooms
        },
        ...getHouseType(house),
        ...getBathroomInHouse(house),
        ...getHeating(house),
        ...getLivingFacilities(house.livingFacilities),
        ...(params?.useB2cFuncs ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant))
    ];

    return mapToInformations(informationsRaw, params);
}

export function buildMainInfoHouse(
    house: ProfOfferHouse,
    params?: {
        useB2cFunc?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    },
    isMobile?: boolean
) {
    const land = isNil(house.land) ?
        [] : buildMainInfoLand(
            house.land,
            {
                useLandIcon: true,
                generateUrl: params?.generateUrl
            },
            isMobile,
            true
        );

    const informationRaw: InfoModelRaw[] = [
        {
            title: isMobile ? 'Дом' : 'Площадь дома',
            value: getHouseArea(house),
            key: InformationsEnum.houseArea,
            icon: InformationsIconEnum.totalArea
        },
        ...land,
        ...getHouseType(house, isMobile),
    ];

    return mapToInformations(informationRaw, params);
}

export function buildAdditionalInfoHouse(
    house: ProfOfferHouse,
    rentTenant?: RentLivingTenantRequirements | null,
    params?: {
        useB2cFunc?: boolean;
        generateUrl?: (params: TGenerateSeoUrlParams) => string;
    }
) {
    const informationRaw: InfoModelRaw[] = [
        {
            title: 'Год постройки',
            value: getBuildYearHouse(house),
            key: InformationsEnum.houseBuildYear,
            icon: InformationsIconEnum.buildYear
        },
        {
            title: 'Этажность',
            value: getFloorsHouse(house),
            key: InformationsEnum.houseFloors,
            icon: InformationsIconEnum.floors
        },
        {
            title: 'Комнат',
            value: getRoomsInHouse(house),
            key: InformationsEnum.houseRooms
        },
        ...getBathroomInHouse(house),
        ...getHeating(house),
        ...getLivingFacilities(house.livingFacilities),
        ...(params?.useB2cFunc ? getTenantsInfoB2c(rentTenant) : getTenantsInfoB2b(rentTenant))
    ];

    return mapToInformations(informationRaw, params);
}
